<template>
    <tr class="no_edit" v-if="!removed">
        <td v-if="pairingCode.id_device" :data-th="'Název zařízení' | translate" class="first_data"><a class="link" @click="toDeviceDetail(pairingCode.id_device)">{{ pairingCode.name }}</a></td>
        <td v-else :data-th="'Název zařízení' | translate" class="first_data">{{ pairingCode.name }}</td>
        <td data-th="Servisní" v-if="$_loggedUser_action_allowed('serviceDevices', 'create')">
          <img v-if="pairingCode.service_code" class="is_set" src="../../../../assets/images/is-set.svg" :alt="'Ano' | translate">
        </td>
        <td :data-th="'Párovací kód' | translate">{{ pairingCode.value }}</td>
        <td :data-th="'Platné do' | translate">{{ pairingCode.expiration_date }}</td>
        <td :data-th="'Vytvořeno' | translate" class="right last_data" v-html="$_date_format(pairingCode.date_created)"></td>
        <td class="no_padding edit">
            <div class="edit_inner">
                <a
                  class="btn btn_action btn_delete"
                  :title="'Smazat' | translate"
                  @click.stop.prevent="emitDeletePairingCode"
                  v-if="isDeletable"
                  v-translate>Smazat
                </a>
            </div>
        </td>
    </tr>
</template>

<script>
	export default {
		name: "PairingCodeRow",
		props: {
			pairingCode: Object
		},
		computed: {
			removed() {
				return this.pairingCode.remove === true
			},
      isDeletable() {
        return !this.pairingCode.service_code || this.$_loggedUser_action_allowed('serviceDevices', 'delete');
      }
		},
		methods: {
			emitDeletePairingCode() {
				this.$emit('delete-pairing-code', this.pairingCode.value)
			},
      toDeviceDetail(id) {
        if(this.$_loggedUser_action_allowed('devices', 'read')) {
          this.$router.push({
            name: 'deviceDetail',
            params: {
              id: id
            }
          });
        }
      }
    }
	}
</script>



// WEBPACK FOOTER //
// src/components/views/subscribers/devices/PairingCodeRow.vue